import { GeneralSetting } from '@apis'

export const fetchByKey = async (state: string) => {
  await GeneralSetting.getByKey(state, state).catch(() => {})
}
